// src/components/ResumesFilterBar.js
//
// Barra de filtros do banco de currículos (Fase G.1.4).
import React from 'react';
import {
  CATEGORY_LABELS,
  AVAILABILITY_TYPES,
  BRAZILIAN_STATES,
} from '../utils/resumeConstants';

const ResumesFilterBar = ({
  search,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  language,
  onLanguageChange,
  state,
  onStateChange,
  city,
  onCityChange,
  availabilityType,
  onAvailabilityChange,
  remoteOnly,
  onRemoteToggle,
  immediateOnly,
  onImmediateToggle,
  onClear,
}) => {
  const hasFilters = search || selectedCategory || language || state || city || availabilityType || remoteOnly || immediateOnly;
  return (
    <div className="bg-white rounded-2xl p-4 mb-5 border border-gray-200">
      <div className="flex flex-wrap gap-3 items-end">
        <label className="flex flex-col text-sm text-gray-700 flex-1 min-w-[180px]">
          Buscar
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Nome, cargo, habilidade…"
            className="border border-gray-300 rounded px-2 h-10 mt-1"
          />
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Área
          <select value={selectedCategory} onChange={(e) => onCategoryChange(e.target.value)} className="border border-gray-300 rounded px-2 h-10 mt-1">
            <option value="">Todas</option>
            {Object.entries(CATEGORY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Idioma
          <input
            type="text"
            value={language}
            onChange={(e) => onLanguageChange(e.target.value)}
            placeholder="Ex.: Inglês"
            className="border border-gray-300 rounded px-2 h-10 mt-1 min-w-[140px]"
          />
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Estado
          <select value={state} onChange={(e) => onStateChange(e.target.value)} className="border border-gray-300 rounded px-2 h-10 mt-1">
            <option value="">Todos</option>
            {BRAZILIAN_STATES.map((uf) => <option key={uf} value={uf}>{uf}</option>)}
          </select>
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Cidade
          <input
            type="text"
            value={city}
            onChange={(e) => onCityChange(e.target.value)}
            placeholder="Cidade"
            className="border border-gray-300 rounded px-2 h-10 mt-1 min-w-[140px]"
          />
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Disponibilidade
          <select value={availabilityType} onChange={(e) => onAvailabilityChange(e.target.value)} className="border border-gray-300 rounded px-2 h-10 mt-1">
            <option value="">Todas</option>
            {Object.entries(AVAILABILITY_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
      </div>
      <div className="flex items-center gap-4 mt-3 text-sm text-gray-700">
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={remoteOnly} onChange={(e) => onRemoteToggle(e.target.checked)} />
          Aceita remoto
        </label>
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={immediateOnly} onChange={(e) => onImmediateToggle(e.target.checked)} />
          Disponibilidade imediata
        </label>
        {hasFilters && (
          <button type="button" onClick={onClear} className="ml-auto text-sm text-pink-600 hover:underline">
            Limpar filtros
          </button>
        )}
      </div>
    </div>
  );
};

export default ResumesFilterBar;
